import {
    FaArrowsRotate,
    FaBolt,
    FaChartColumn,
    FaClipboardCheck,
    FaCode,
    FaCoins,
    FaFileInvoiceDollar,
    FaMagnifyingGlassDollar,
    FaMoneyCheckDollar,
    FaPaperPlane,
    FaShieldHalved,
    FaTriangleExclamation,
    FaUserPlus,
    FaUserShield,
    FaWallet,
} from "react-icons/fa6";

export const benefitsData = [
    {
        title: "Patient Registration",
        description:
            "We start by collecting detailed demographic and insurance data. This ensures accurate registration and verifies eligibility for smooth billing.",
        icon: FaUserPlus,
    },
    {
        title: "Precise Medical Coding",
        description:
            "Our certified coders assign accurate codes to each service, maximizing your claims' chances of reimbursement and ensuring compliance with the latest coding standards.",
        icon: FaCode,
    },
    {
        title: "Billing Solutions",
        description:
            "Our billing team processes each claim efficiently. We use accurate coding to prepare it for quick submission to insurers. This ensures timely reimbursements for your practice.",
        icon: FaFileInvoiceDollar,
    },
    {
        title: "Strict Quality Control",
        description:
            "We review claims and documents to avoid payment delays and fix any errors before submission for fast processing.",
        icon: FaClipboardCheck,
    },
    {
        title: "Efficient Claim Submission",
        description:
            "We have a 97% first-pass clean rate. So, we can submit claims accurately and efficiently. This leads to faster reimbursements and fewer delays.",
        icon: FaPaperPlane,
    },
    {
        title: "Payment Posting",
        description:
            "Our team promptly posts all payments received. This keeps your practice's financial records accurate for easy tracking.",
        icon: FaMoneyCheckDollar,
    },
    {
        title: "Denial Management",
        description:
            "If claims are denied, our experts will review, adjust, and resubmit them. We track each claim and follow up with payers to ensure quick resolution and payment.",
        icon: FaTriangleExclamation,
    },
    {
        title: "A/R Follow-Up",
        description:
            "To keep cash flow steady, our team follows up on unpaid claims. This ensures payments and keeps your accounts receivable in check.",
        icon: FaMagnifyingGlassDollar,
    },
];

export const featuresCardData = [{
    id: 1,
    icon: <FaUserShield />,
    title: "Expertise You Can Trust",
    description:
        "We have certified coders with expertise in many medical specialties. They ensure accurate coding and compliance with guidelines.",
},
{
    id: 2,
    icon: <FaBolt />,
    title: "Fast & Reliable Processing",
    description:
        "We focus on swift claims submission, helping your practice receive payments faster. By minimizing delays, we keep your cash flow constant and reduce the risk of revenue loss.",
},
{
    id: 3,
    icon: <FaShieldHalved />,
    title: "Dedication to Compliance",
    description:
        "Our coders stay updated on evolving coding rules. This reduces claim rejections and supports accurate, compliant claim processing.",
}];


export const collectionStepsData = [
    {
        id: 1,
        number: "01",
        icon: <FaFileInvoiceDollar />,
        title: "Timely Invoice Creation",
        description: "Create invoices fast for timely billing.",
    },
    {
        id: 2,
        number: "02",
        icon: <FaArrowsRotate />,
        title: "Accurate System Updates",
        description: "Keep billing records accurate and current.",
    },
    {
        id: 3,
        number: "03",
        icon: <FaMoneyCheckDollar />,
        title: "Reliable Payment Collection",
        description: "Collect payments faster with proper follow-ups.",
    },
    {
        id: 4,
        number: "04",
        icon: <FaCoins />,
        title: "Handling Partial Payments",
        description: "Manage partial payments with accurate tracking.",
    },
    {
        id: 5,
        number: "05",
        icon: <FaChartColumn />,
        title: "Detailed Reporting Systems",
        description: "Track claims and payments with reports.",
    },
    {
        id: 6,
        number: "06",
        icon: <FaWallet />,
        title: "Cash Oversight Details",
        description: "Monitor cash flow and payment gaps.",
    },
];